import React from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import { CoSupervisorDeclaration } from './CoSupervisorDeclaration';
import {
  MONITOR_SIDEBAR_MODULE,
  MonitorSideBar,
  StudentApplication,
  SupervisorNomination,
} from '../../../../Monitor/components';
import { PAGE_COMMON_TEXT } from '../../../../Monitor/components/lang';
import { useGetCoSupervisorDec } from '../../../graphql';
import { Alert, Loading } from '../../../../../components';
import { useAuth } from '../../../../../contexts';

const SIDEBAR_TEXT = PAGE_COMMON_TEXT.SIDEBAR_TEXT;
export const CoSupervisorNomination: React.FunctionComponent = () => {
  const { nominationId = '' } = useParams();

  const [activatedModuleId, setActivatedModuleId] = React.useState(
    MONITOR_SIDEBAR_MODULE.DECLARATION,
  );

  const { CoSupervisorDec, loading, error, refetch } =
    useGetCoSupervisorDec(nominationId);
  const { user } = useAuth();
  const { userInfo } = user ?? {};

  // if internal supervisors enter from system list, then userInfo?.emailAddress is undefined
  // userInfo?.netId be the backup
  const supervisorEmail = userInfo?.emailAddress ?? '';
  const coSupInfoHistory = CoSupervisorDec.find(
    sup => sup?.email === supervisorEmail || sup?.netId === userInfo?.netId,
  );

  const submitted: boolean = coSupInfoHistory?.confirmedAsCoSupervisor ?? false;

  const coSupervisorDeclarationRemark =
    coSupInfoHistory?.coSupervisorDeclarationRemark ?? '';

  const handleChangeActivated = (activatedId: MONITOR_SIDEBAR_MODULE): void => {
    setActivatedModuleId(activatedId);
  };
  const monitorModulesMap: Partial<
    Record<
      MONITOR_SIDEBAR_MODULE,
      { component: React.ReactNode; moduleTitle: string }
    >
  > = {
    [MONITOR_SIDEBAR_MODULE.STUDENT_APPLICATION]: {
      component: <StudentApplication />,
      moduleTitle: SIDEBAR_TEXT.STUDENT_APPLICATION,
    },
    [MONITOR_SIDEBAR_MODULE.SUPERVISOR_NOMINATION]: {
      component: <SupervisorNomination />,
      moduleTitle: SIDEBAR_TEXT.SUPERVISOR_NOMINATION,
    },
    [MONITOR_SIDEBAR_MODULE.DECLARATION]: {
      component: (
        <CoSupervisorDeclaration
          coSupEmail={supervisorEmail}
          coSupervisorDeclarationRemark={coSupervisorDeclarationRemark}
          nominationId={nominationId}
          refetchCoSupDec={refetch}
          submitted={submitted}
        />
      ),
      moduleTitle: SIDEBAR_TEXT.DECLARATION,
    },
  };

  const activatedModule:
    | { component: React.ReactNode; moduleTitle: string }
    | undefined = monitorModulesMap[activatedModuleId];

  const moduleComponent = activatedModule?.component ?? activatedModuleId;
  const moduleTitle = activatedModule?.moduleTitle ?? activatedModuleId;

  if (error)
    return (
      <Alert
        openAlert={true}
        setOpenAlert={() => {}}
        alertDetails={{
          alertContent: 'Error Occurs.' + (error as Error)?.message,
          alertType: 'error',
        }}
      />
    );

  return (
    <PageContainer>
      <div className="sidebar-area">
        <MonitorSideBar
          onChangeActivated={handleChangeActivated}
          activatedModule={activatedModuleId}
          generalMode={false}
        />
      </div>
      {loading ? (
        <Loading />
      ) : (
        <Container>
          <h1>{moduleTitle}</h1>
          <div className="form-area">{moduleComponent}</div>
        </Container>
      )}
    </PageContainer>
  );
};

const PageContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  flex: 1;
  width: 100%;

  .sidebar-area {
    width: 18.5rem;
    padding-right: 0.1rem;
  }

  h1 {
    margin-top: 2rem;
    font-size: 1.5rem;
    font-weight: 700;
    text-align: center;
    color: #951d1d;
  }
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .form-area {
    padding: 1.25rem;
    display: flex;
    flex-direction: column;
    flex: 1;
    width: 100%;
    min-height: 100vh;
  }
`;
